export default __webpack_public_path__ + "static/media/038-clippers.dc83e8ed.svg";